import RollingDateConfig from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateConfig';
import { RANGE_OPERATOR_TYPES } from '../constants/rollingDateRange';
const fromRollingDateRangeOperation = (Operator, field, {
  operation
}) => {
  const {
    direction,
    isInclusive,
    includeFutureDates
  } =
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  RANGE_OPERATOR_TYPES[operation.operator];
  return Operator.of(field, RollingDateConfig({
    direction,
    includeFutureDates,
    useFiscalYear: operation.useFiscalYear === true,
    isInclusive,
    timeUnit: operation.timeUnit,
    value: operation.timeUnitCount
  }), 0);
};
export { fromRollingDateRangeOperation };